module.exports = __webpack_public_path__ + "img/lego-globe.c06a588a.svg";